import React from "react";
import { withTranslate } from 'react-redux-multilingual';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function SnackbarAlert(props) {
    const { translate, obj } = props;

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    return (
    <Snackbar open={obj?.open} autoHideDuration={6000} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} onClose={obj?.handleClose}>
        <Alert onClose={obj?.handleClose} severity={obj?.severity} sx={{ width: '100%' }}>
        {obj?.message}
        </Alert>
    </Snackbar>
    )
}

export default withTranslate(SnackbarAlert);